import React from "react";
import { socialLinks } from "../constants/social";
import { images } from "../constants";

const SocialMedia = () => {
  return (
    <div className="app__social">
    {socialLinks.map((link) => {
      const Icon = link.icon;
  
      return (
        <a
          key={link.id}
          href={link.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={link.label}
          title={link.label}
          className="app__social-logo"
        >
          <Icon size={20} />
        </a>
      );
    })}
  </div>
  
  );
};

export default SocialMedia;
